import { render } from "./FlowAddButton.vue?vue&type=template&id=11a9eabc&scoped=true"
import script from "./FlowAddButton.vue?vue&type=script&lang=ts"
export * from "./FlowAddButton.vue?vue&type=script&lang=ts"

import "./FlowAddButton.vue?vue&type=style&index=0&id=11a9eabc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-11a9eabc"

export default script